/* BVA "Bygg ditt hydraulset" — guided build. Narrows the catalogue step by step
   and never offers a pump that cannot fill the chosen cylinder. Compatibility
   rules come from bva-compat.js, which the PDP block shares. */
(function () {
  'use strict';

  var ROLLNAMN = {
    cylinder: 'Cylinder', pump: 'Pump', hose: 'Hydraulslang', coupling: 'Snabbkoppling',
    gauge: 'Manometer', gauge_adapter: 'Manometeradapter', oil: 'Hydraulolja'
  };
  var TILLBEHOR = ['hose', 'coupling', 'gauge', 'gauge_adapter', 'oil'];
  var PUMPNAMN = { hand: 'Handpump', foot: 'Fotpump', air: 'Tryckluftsdriven', electric: 'Elektrisk' };
  var CYLNAMN = { standard: 'Standardcylinder', flat: 'Lågprofil', hollow: 'Hålcylinder', pull: 'Dragcylinder' };

  function kr(ore) {
    return Math.round(ore / 100).toLocaleString('sv-SE').replace(/ | /g, ' ') + ' kr';
  }
  function las(rot, valjare) {
    var el = rot.querySelector(valjare);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function tomma(el) { while (el.firstChild) el.removeChild(el.firstChild); }

  function init(rot) {
    if (rot.__bvac) return;
    rot.__bvac = true;
    var spara = window.vpSpara || function () {};

    var C = window.BVACompat;
    var cylindrar = (las(rot, '[data-bvac-cylinders]') || []).map(function (c) {
      c.tonnage = Number(c.tonnage);
      c.stroke_mm = Number(c.stroke_mm);
      c.oil_required_cm3 = Number(c.oil_required_cm3) || null;
      if (typeof c.application === 'string') {
        try { c.application = JSON.parse(c.application); } catch (e) { c.application = []; }
      }
      if (!Array.isArray(c.application)) c.application = [];
      return c;
    });
    var pumpar = (las(rot, '[data-bvac-pumps]') || []).map(function (p) {
      p.oil_capacity_cm3 = Number(p.oil_capacity_cm3) || 0; return p;
    });
    var delar = las(rot, '[data-bvac-parts]') || [];

    var val = { anvandning: null, kraft: null, slag: null, cylinder: null, pump: null, delar: {} };

    // Preselect the parts marked as standard - the ones that actually connect a
    // cylinder to a pump. Cheapest is not the same thing.
    TILLBEHOR.forEach(function (roll) {
      var kandidater = delar.filter(function (d) { return d.role === roll; });
      var standard = kandidater.filter(function (d) { return d.standard; })[0] || kandidater[0];
      if (standard) val.delar[roll] = { produkt: standard, pa: true };
    });

    var el = {
      anvandning: rot.querySelector('[data-bvac-anvandning]'),
      kraft: rot.querySelector('[data-bvac-kraft]'),
      slag: rot.querySelector('[data-bvac-slag]'),
      cylinderlista: rot.querySelector('[data-bvac-cylinderlista]'),
      cylinderhint: rot.querySelector('[data-bvac-cylinderhint]'),
      pumplista: rot.querySelector('[data-bvac-pumplista]'),
      pumphint: rot.querySelector('[data-bvac-pumphint]'),
      delar: rot.querySelector('[data-bvac-delar]'),
      poster: rot.querySelector('[data-bvac-poster]'),
      total: rot.querySelector('[data-bvac-total]'),
      exmoms: rot.querySelector('[data-bvac-exmoms]'),
      add: rot.querySelector('[data-bvac-add]'),
      note: rot.querySelector('[data-bvac-note]'),
      stegCylinder: rot.querySelector('[data-bvac-steg="cylinder"]'),
      stegPump: rot.querySelector('[data-bvac-steg="pump"]'),
      stegDelar: rot.querySelector('[data-bvac-steg="delar"]'),
      panel: rot.querySelector('[data-bvac-panel]'),
      vaxla: rot.querySelector('[data-bvac-vaxla]')
    };

    // Under 1000px ligger panelen sist i floden, efter sex steg. Sa fort setet
    // har innehall lyfter CSS:en den till en fast rad i underkant - vaxlaren
    // fäller ut posterna sa man kan granska dem utan att scrolla tillbaka.
    if (el.vaxla) {
      el.vaxla.addEventListener('click', function () {
        var oppen = el.panel.classList.toggle('ar-oppen');
        el.vaxla.setAttribute('aria-expanded', String(oppen));
        el.vaxla.querySelector('.bvac-vaxla-text').textContent = oppen ? 'Dölj delarna' : 'Visa delarna';
      });
    }

    function valjKnapp(behallare, knapp) {
      behallare.querySelectorAll('.bvac-knapp').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b === knapp));
      });
    }

    el.anvandning.addEventListener('click', function (e) {
      var k = e.target.closest('.bvac-knapp'); if (!k) return;
      val.anvandning = k.getAttribute('data-varde');
      spara('bva_konfigurator_steg', { steg: 1, val: val.anvandning });
      valjKnapp(el.anvandning, k);
      val.cylinder = null; val.pump = null;
      ritaCylindrar();
    });
    [['kraft', el.kraft], ['slag', el.slag]].forEach(function (par) {
      par[1].addEventListener('click', function (e) {
        var k = e.target.closest('.bvac-knapp'); if (!k) return;
        val[par[0]] = { min: Number(k.getAttribute('data-min')), max: Number(k.getAttribute('data-max')) };
        spara('bva_konfigurator_steg', { steg: par[0] === 'kraft' ? 2 : 3, val: k.textContent.trim().slice(0, 40) });
        valjKnapp(par[1], k);
        val.cylinder = null; val.pump = null;
        ritaCylindrar();
      });
    });

    function passandeCylindrar() {
      return cylindrar.filter(function (c) {
        if (!c.available) return false;
        if (val.anvandning && c.application.length && c.application.indexOf(val.anvandning) === -1) return false;
        if (val.kraft && (c.tonnage < val.kraft.min || c.tonnage > val.kraft.max)) return false;
        if (val.slag && (c.stroke_mm < val.slag.min || c.stroke_mm > val.slag.max)) return false;
        return true;
      }).sort(function (a, b) { return a.tonnage - b.tonnage || a.stroke_mm - b.stroke_mm; });
    }

    function rad(produkt, meta, vald) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bvac-rad';
      b.setAttribute('aria-pressed', String(!!vald));
      b.innerHTML =
        '<span>' + (produkt.image ? '<img src="' + produkt.image + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span><span class="namn">' + produkt.title + '</span><span class="meta">' + meta + '</span></span>' +
        '<span class="pris">' + kr(produkt.price) + '</span>';
      return b;
    }

    function ritaCylindrar() {
      var klara = val.anvandning && val.kraft && val.slag;
      el.stegCylinder.classList.toggle('bvac-lasad', !klara);
      tomma(el.cylinderlista);
      if (!klara) {
        el.cylinderhint.textContent = 'Svara på frågorna ovan så visas cylindrarna som passar.';
        ritaPumpar(); return;
      }
      var lista = passandeCylindrar();
      if (!lista.length) {
        el.cylinderhint.textContent = 'Ingen cylinder matchar just den kombinationen.';
        spara('bva_konfigurator_tomt', { typ: 'cylinder', anvandning: val.anvandning,
          kraft: val.kraft.min + '-' + val.kraft.max, slag: val.slag.min + '-' + val.slag.max });
        el.cylinderlista.innerHTML =
          '<p class="bvac-tom">Prova ett bredare spann, eller <a href="/pages/offert">be oss ta fram ett förslag</a>.</p>';
        ritaPumpar(); return;
      }
      el.cylinderhint.textContent = lista.length + ' cylindrar passar. Välj en så räknar vi ut pumpbehovet.';
      lista.forEach(function (c) {
        var meta = (CYLNAMN[c.cylinder_type] || '') + ' · ' + c.tonnage + ' ton · ' + c.stroke_mm + ' mm slag' +
          (c.acting === 'double' ? ' · dubbelverkande' : '');
        var b = rad(c, meta, val.cylinder && val.cylinder.handle === c.handle);
        b.addEventListener('click', function () {
          val.cylinder = c; val.pump = null;
          spara('bva_cylinder_vald', { produkt: c.handle, ton: c.tonnage, pris: Math.round(c.price / 100) });
          ritaCylindrar(); ritaPumpar(); ritaPanel();
        });
        el.cylinderlista.appendChild(b);
      });
      ritaPumpar();
    }

    function ritaPumpar() {
      tomma(el.pumplista);
      el.stegPump.classList.toggle('bvac-lasad', !val.cylinder);
      if (!val.cylinder) {
        el.pumphint.textContent = 'Bara pumpar som rymmer tillräckligt med olja för din cylinder visas här.';
        ritaDelar(); ritaPanel(); return;
      }
      var behov = C.oilRequired(val.cylinder);
      var krav = C.requiredPumpCapacity(val.cylinder);
      var lista = C.matchingPumps(val.cylinder, pumpar.filter(function (p) { return p.available; }));
      if (!lista.length) {
        el.pumphint.textContent = 'Ingen lagerförd pump räcker till den här cylindern.';
        spara('bva_konfigurator_tomt', { typ: 'pump', cylinder: val.cylinder.handle, krav_cm3: krav });
        el.pumplista.innerHTML = '<p class="bvac-tom">Cylindern behöver minst <strong>' + krav +
          ' cm³</strong>. <a href="/pages/offert">Kontakta oss så tar vi fram rätt pump.</a></p>';
        ritaDelar(); ritaPanel(); return;
      }
      el.pumphint.textContent = 'Cylindern drar ' + behov + ' cm³, så pumpen måste rymma minst ' +
        krav + ' cm³ med marginal för slangen. ' + lista.length + ' pumpar klarar det.';
      if (!val.pump) val.pump = lista[0];
      lista.forEach(function (p) {
        var meta = (PUMPNAMN[p.pump_type] || 'Pump') + ' · ' + p.oil_capacity_cm3 + ' cm³' +
          (p.acting === 'double' ? ' · dubbelverkande' : '');
        var b = rad(p, meta, val.pump && val.pump.handle === p.handle);
        b.addEventListener('click', function () {
          val.pump = p; spara('bva_pump_vald', { produkt: p.handle, cm3: p.oil_capacity_cm3 });
          ritaPumpar(); ritaPanel();
        });
        el.pumplista.appendChild(b);
      });
      ritaDelar(); ritaPanel();
    }

    function ritaDelar() {
      tomma(el.delar);
      var kretsar = C.circuitCount(val.cylinder);
      TILLBEHOR.forEach(function (roll) {
        var post = val.delar[roll]; if (!post) return;
        var kandidater = delar.filter(function (d) { return d.role === roll; });
        var antal = (roll === 'hose' || roll === 'coupling') ? kretsar : 1;

        var rad = document.createElement('label');
        rad.className = 'bvac-kryssrad';
        var kryss = document.createElement('input');
        kryss.type = 'checkbox'; kryss.checked = post.pa;
        kryss.addEventListener('change', function () { post.pa = kryss.checked; ritaPanel(); });

        var mitt = document.createElement('span');
        if (kandidater.length > 1) {
          var valj = document.createElement('select');
          kandidater.forEach(function (d) {
            var o = document.createElement('option');
            o.value = d.handle;
            o.textContent = d.title + ' — ' + kr(d.price);
            if (d.handle === post.produkt.handle) o.selected = true;
            valj.appendChild(o);
          });
          valj.addEventListener('change', function () {
            post.produkt = kandidater.filter(function (d) { return d.handle === valj.value; })[0] || post.produkt;
            ritaDelar(); ritaPanel();
          });
          mitt.appendChild(document.createTextNode(ROLLNAMN[roll] + (antal > 1 ? ' × ' + antal : '') + ' '));
          mitt.appendChild(valj);
        } else {
          mitt.textContent = ROLLNAMN[roll] + (antal > 1 ? ' × ' + antal : '') + ': ' + post.produkt.title;
        }

        var pris = document.createElement('span');
        pris.className = 'pris';
        pris.textContent = kr(post.produkt.price * antal);

        rad.appendChild(kryss); rad.appendChild(mitt); rad.appendChild(pris);
        el.delar.appendChild(rad);
      });
      if (kretsar > 1) {
        var not = document.createElement('p');
        not.className = 'bvac-note';
        not.textContent = 'Dubbelverkande cylinder: slang och koppling behövs i två uppsättningar, en för varje riktning.';
        el.delar.appendChild(not);
      }
    }

    function poster() {
      var ut = [];
      if (val.cylinder) ut.push({ role: 'cylinder', product: val.cylinder, qty: 1 });
      if (val.pump) ut.push({ role: 'pump', product: val.pump, qty: 1 });
      if (!val.cylinder) return ut;
      var kretsar = C.circuitCount(val.cylinder);
      TILLBEHOR.forEach(function (roll) {
        var post = val.delar[roll];
        if (!post || !post.pa) return;
        ut.push({ role: roll, product: post.produkt, qty: (roll === 'hose' || roll === 'coupling') ? kretsar : 1 });
      });
      return ut;
    }

    function ritaPanel() {
      var lista = poster();
      rot.classList.toggle('har-set', lista.length > 0);
      tomma(el.poster);
      if (!lista.length) {
        el.poster.innerHTML = '<p class="bvac-note">Inga delar valda än.</p>';
        el.total.textContent = '—';
        el.exmoms.textContent = '';
        el.add.disabled = true;
        el.note.textContent = '';
        return;
      }
      lista.forEach(function (p) {
        var d = document.createElement('div');
        d.className = 'bvac-post';
        d.innerHTML = '<span class="roll">' + (ROLLNAMN[p.role] || p.role) + (p.qty > 1 ? ' × ' + p.qty : '') + '</span>' +
          '<span>' + p.product.title + '</span>' +
          '<span class="pris">' + kr(p.product.price * p.qty) + '</span>';
        el.poster.appendChild(d);
      });

      var summa = C.kitTotal(lista);
      var visaRabatt = rot.getAttribute('data-bva-rabatt') === 'true' && C.qualifiesForBundle(lista);
      var rabatt = visaRabatt ? Math.round(summa * C.BUNDLE_RATE) : 0;
      el.total.innerHTML = kr(summa - rabatt) +
        (rabatt ? ' <span class="bvac-rabatt">−' + kr(rabatt) + '</span>' : '');
      el.exmoms.textContent = kr(Math.round((summa - rabatt) / 1.25)) + ' exkl. moms';

      var komplett = val.cylinder && val.pump;
      el.add.disabled = !komplett;
      el.note.textContent = komplett
        ? (visaRabatt ? 'Paketrabatt 5 % dras av automatiskt i kassan.'
                      : 'Alla delar läggs i varukorgen i ett svep. Du kan ändra antal i kassan.')
        : 'Välj både cylinder och pump för att lägga till setet.';
    }

    el.add.addEventListener('click', function () {
      var lista = poster().filter(function (p) { return p.product.variant_id; });
      if (!lista.length) return;
      el.add.disabled = true;
      var text = el.add.textContent;
      el.add.textContent = 'Lägger till …';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: lista.map(function (p) { return { id: p.product.variant_id, quantity: p.qty }; }) })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        spara('bva_set_tillagt', { kalla: 'konfigurator', artiklar: lista.length,
          varde: Math.round(C.kitTotal(lista) / 100), currency: 'SEK' });
        el.add.textContent = 'Tillagt ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () { window.location.href = '/cart'; }, 700);
      }).catch(function () {
        el.add.disabled = false;
        el.add.textContent = text;
      });
    });

    ritaCylindrar();
    ritaDelar();
    ritaPanel();
  }

  function start() { document.querySelectorAll('[data-bva-config]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
